import {useNavigate} from 'react-router-dom';

export function useMovePage() {
    const navigate = useNavigate();
  
    const movePage = (value) => {
        navigate(`${value}`);
        window.scrollTo(0, 0); // 페이지 이동 후 스크롤을 최상단으로
    };

    return movePage;
}
